"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInput = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Menu_1 = require("./Menu");
const use_autocomplete_1 = require("./use-autocomplete");
const SearchInput = (props) => {
    const context = React.useContext(Menu_1.MenuContext);
    const [query, setQuery] = React.useState('');
    const [active, setActive] = React.useState(0);
    const input = React.useRef(null);
    const autoCompleteList = React.useRef(null);
    const formRef = React.useRef(null);
    React.useEffect(() => {
        input.current.focus();
    }, []);
    const onChange = (e) => {
        setQuery(e.target.value);
        handleGetAutocomplete(e.target.value);
    };
    const closeSearch = () => {
        context.setMenuState(Object.assign(Object.assign({}, context.menuState), { searchVisible: !context.menuState.searchVisible }));
    };
    const saveSearch = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const res = yield fetch('https://pmapi.reeltime.no/newapi/savesearch', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    q: query.toLowerCase(),
                }),
            });
            return true;
        }
        catch (e) {
            console.log('feil ved søk');
        }
    });
    const handleSubmit = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        closeSearch();
        yield saveSearch();
        document.location.href = `https://privatmegleren.no?q=${encodeURIComponent(query.toLowerCase())}`;
    });
    const { list, handleGetAutocomplete } = (0, use_autocomplete_1.useAutocomplete)({
        query: query,
    });
    const close = () => {
        context.setMenuState(Object.assign(Object.assign({}, context.menuState), { searchVisible: !context.menuState.searchVisible }));
    };
    const focusChange = (e) => {
        if (e.keyCode === 40) {
            e.preventDefault();
            if (autoCompleteList && autoCompleteList.current) {
                autoCompleteList.current.focus();
            }
            setActive(1);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(SearchWrap, null,
            React.createElement("form", { ref: formRef, action: ".", onSubmit: handleSubmit },
                React.createElement(SearchIcon, null,
                    React.createElement("svg", { width: "31", height: "31", viewBox: "0 0 31 31", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        React.createElement("path", { d: "M29.7224 27.2685L20.605 18.1494C22.0073 16.3081 22.7964 13.9408 22.7964 11.3976C22.7964 5.08477 17.7116 0 11.3988 0C5.08597 0 -0.000488281 5.08645 -0.000488281 11.3993C-0.000488281 17.7121 5.08428 22.7969 11.3971 22.7969C13.9403 22.7969 16.2188 22.0078 18.1489 20.6055L27.268 29.7246C27.6181 30.0747 28.0571 30.2506 28.496 30.2506C28.935 30.2506 29.3722 30.0747 29.7241 29.7246C30.4244 29.0226 30.4244 27.9704 29.7224 27.2685L29.7224 27.2685ZM11.3988 19.2903C7.01432 19.2903 3.50776 15.7837 3.50776 11.3993C3.50776 7.01481 7.01432 3.50825 11.3988 3.50825C15.7833 3.50825 19.2898 7.01481 19.2898 11.3993C19.2898 15.7821 15.7816 19.2903 11.3988 19.2903Z", fill: "" }))),
                React.createElement(Input, { type: "search", placeholder: "Skriv ditt s\u00F8keord her..", ref: input, value: query, onChange: onChange, onKeyDown: focusChange, autoFocus: true })),
            React.createElement("div", null, list && list.length && query ? (React.createElement(StyledAutocompleteList, { tabIndex: -1, ref: autoCompleteList, onKeyDown: (e) => {
                    e.preventDefault();
                    if (e.keyCode === 38) {
                        const prevIndex = active === 0 ? active : active - 1;
                        setActive(prevIndex);
                        setQuery(list[prevIndex].text);
                        if (active === 0) {
                            console.log('nå traff denne');
                        }
                    }
                    else if (e.keyCode === 40) {
                        const nextIndex = active + 1 < list.length ? active + 1 : active;
                        setActive(nextIndex);
                        setQuery(list[nextIndex].text);
                    }
                    else if (e.keyCode === 13) {
                        setQuery(list[active].text);
                        handleSubmit(e);
                    }
                } }, list.map((item, index) => (React.createElement(StyledAutocompleteListItem, { id: `a_${index}`, active: active === index, tabIndex: index, key: `a_${index}`, onFocus: () => {
                    setQuery(item.text);
                }, onClick: (e) => {
                    setQuery(item.text);
                    handleSubmit(e);
                } }, item.text))))) : null))));
};
exports.SearchInput = SearchInput;
const SearchWrap = styled_components_1.default.div `
  position: absolute;
  left: 0;
  top: 64px;
  right: 0;
  bottom: 0px;
  margin: 0 30px;

  @media (min-width: 1140px) {
    left: 12px;
    top: 13px;
    right: 0;
    top: 14px;
    bottom: 0px;
    width: calc(100% - 140px);
    margin: auto;

    svg {
      width: 18px;
      height: 18px;
      fill: rgb(100, 100, 100);
    }
  }
`;
const SearchIcon = styled_components_1.default.div `
  position: absolute;
  top: 7px;
  bottom: 0px;
  width: 18px;
  height: 18px;
  margin-left: 10px;
  z-index: 1;

  svg {
    fill: rgb(100, 100, 100) !important;
  }
`;
const Input = styled_components_1.default.input `
  width: 100%;
  font-size: 18px;
  font-weight: 400;
  color: rgb(255, 255, 255) !important;
  appearance: none;
  padding: 0.5rem 0.9375rem 0.5rem 2.25rem !important;
  border-width: initial;
  border-style: none;
  border-color: initial;
  border-image: initial;
  outline: none;
  border: none !important;
  background: rgb(30, 30, 30) !important;
  border-radius: 0px;
  height: 37px;
`;
const StyledAutocompleteList = styled_components_1.default.ul `
  position: absolute;
  top: 2.3125rem;
  padding: 0;
  margin: 0;
  width: 100%;
  background: rgb(25, 25, 25);
  list-style: none;
  outline: none;
`;
const StyledAutocompleteListItem = styled_components_1.default.li `
  padding: 0.5rem 0.9375rem !important;
  margin: 0 !important;
  color: white;
  border-bottom: solid 1px rgb(40, 40, 40);
  ${(props) => (props.active ? `background: rgb(35, 35, 35);` : '')}

  &:last-child {
    border-bottom: none;
  }

  &:focus {
    background: rgb(35, 35, 35);
    outline: none;
  }

  &:hover {
    cursor: pointer;
    background: rgb(35, 35, 35);
  }
`;
const Close = styled_components_1.default.div `
  display: inline;
  color: white;
  font-size: 18px;
  font-weight: 300;
  cursor: pointer;
`;
//# sourceMappingURL=search-input.js.map